<admin-header [primaryButtons]="headerPrimaryButtons" [secondaryButtons]="headerSecondaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div id="dashboard-container">
	<div *ngIf="mode === 'Data Health'" id="dataHealth">
		<div class="datahealth-grid">
			<div *ngFor="let m of dataHealth" class="datahealth-card">
				<div class="datahealth-card-header">
					<h3>{{ m.title }}</h3>
					<div class="datahealth-progress-wrapper">
						<span class="datahealth-status-label" style="margin-bottom:10px" [ngClass]="'datahealth-status-' + renderRingColour(m.healthPercentage)">{{ m.healthPercentage.toFixed(2) + "%" }}</span>
						<svg class="datahealth-ring" viewBox="0 0 36 36">
							<path class="datahealth-ring-track" [attr.stroke]="renderRingColour(m.healthPercentage)" d="M18 2a16 16 0 1 1 0 32 16 16 0 1 1 0-32" />
							<path class="datahealth-ring-progress" [attr.stroke]="renderRingColour(m.healthPercentage)" [attr.stroke-dasharray]="m.healthPercentage + ', 100'" d="M18 2a16 16 0 1 1 0 32 16 16 0 1 1 0-32" />
							<text x="18" y="21" text-anchor="middle" class="datahealth-ring-label"></text>
						</svg>
						<span class="datahealth-status-label" style="flex:1" [ngClass]="'datahealth-status-' + renderRingColour(m.healthPercentage)">{{ renderRingStatus(m.healthPercentage) }}</span>
					</div>
				</div>
				<div class="datahealth-metrics" style="margin-top:80px;">
					<div>
						<span>Total Records</span><span>{{ m.totalItems }}</span>
					</div>
					<div *ngFor="let stat of m.stats">
						<span>{{stat.title}}</span><span>{{ stat.items }}</span>
					</div>
					<!-- <div>
						<span>Last Updated</span><span>{{ m.updatedAgo }}</span>
					</div> -->
				</div>
			</div>
		</div>

		<!-- <div class="datahealth-bottom-grid"> -->
		<!-- <div class="datahealth-panel">
				<h3>System Performance</h3>
				<div>
					<div>
						<span>Database Size</span>
						<span>{{ systemStats.dbSize }}</span>
					</div>
					<div>
						<span>Query Response Time</span>
						<span class="text-green">{{ systemStats.queryTime }}</span>
					</div>
					<div>
						<span>Active Connections</span>
						<span class="text-blue">{{ systemStats.connections }}</span>
					</div>
				</div>
			</div> -->
		<!-- <div class="datahealth-panel">
				<h3>7-Day Trend</h3>
				<div>
					<div>
						<span>Overall Score</span>
						<span class="text-green">{{ trends.score }}</span>
					</div>
					<div>
						<span>New Issues</span>
						<span class="text-yellow">{{ trends.newIssues }}</span>
					</div>
					<div>
						<span>Resolved Issues</span>
						<span class="text-green">{{ trends.resolved }}</span>
					</div>
				</div>
			</div> -->
		<!-- <div class="datahealth-panel">
				<h3>Quick Actions</h3>
				<div class="datahealth-actions">
					<button>
						<i class="fas fa-broom"></i> Run Data Cleanup
					</button>
					<button>
						<i class="fas fa-search"></i> Find Duplicates
					</button>
					<button>
						<i class="fas fa-file-export"></i> Export Report
					</button>
				</div>
			</div>
		</div> -->
		<!-- <div class="row">
			<div *ngFor="let dataHealthColumn of dataHealth" class="col-3">
				<ul class="{{dataHealthColumn.class}}">
					<li>
						<dx-bar-gauge
							[startValue]="0"
							[endValue]="100"
							[values]="[dataHealthColumn.healthPercentage]"
						>
							<dxo-label [customizeText]="healthLabelText"
								><dxo-format
									type="fixedPoint"
									[precision]="2"
								></dxo-format
							></dxo-label>
							<dxo-export [enabled]="false"></dxo-export>
							<dxo-title text="{{dataHealthColumn.title}}"
								><dxo-font [size]="22"></dxo-font
							></dxo-title>
						</dx-bar-gauge>
					</li>
					<li>
						<strong>Total</strong>
						<span>{{dataHealthColumn.totalItems}}</span>
					</li>
					<li *ngFor="let stat of dataHealthColumn.stats">
						<strong>{{stat.title}}</strong>
						<span>{{stat.items}}</span>
					</li>
				</ul>
			</div>
		</div> -->
	</div>
	<div *ngIf="mode === 'Financial'" id="Financial">
		<div *ngIf="financialDashboardMode == 'Financials'">
			<div class="financial-summary-section">
				<div class="financial-summary-grid">
					<!-- Invoice Value -->
					<div class="financial-summary-card financial-green">
						<div class="financial-summary-header">
							<div>
								<p class="financial-label">Total Invoice Value</p>
								<p class="financial-value">£{{formatCurrency(financial.invoiceValue.toFixed(2))}}</p>
								<!-- <p *ngIf="financial.invoiceValueChange > 0" class="financial-change financial-up">
									<i class="fas fa-arrow-up"></i> +{{financial.invoiceValueChange.toFixed(1)}}% from last
									month
								</p>
								<p *ngIf="financial.invoiceValueChange < 0" class="financial-change financial-down">
									<i class="fas fa-arrow-down"></i> -{{financial.invoiceValueChange.toFixed(1)}}% from last
									month
								</p> -->
							</div>
							<div class="financial-icon-container financial-green-bg">
								<i class="fas fa-pound-sign"></i>
							</div>
						</div>
					</div>

					<!-- Invoice Count -->
					<div class="financial-summary-card financial-blue">
						<div class="financial-summary-header">
							<div>
								<p class="financial-label">Total Invoice Count</p>
								<p class="financial-value">{{financial.invoiceCount}}</p>
								<!-- <p *ngIf="financial.invoiceCountChange > 0" class="financial-change financial-up">
									<i class="fas fa-arrow-up"></i> +{{financial.invoiceCountChange.toFixed(1)}} from last
									month
								</p>
								<p *ngIf="financial.invoiceCountChange < 0" class="financial-change financial-down">
									<i class="fas fa-arrow-down"></i> -{{financial.invoiceCountChange.toFixed(1)}} from last
									month
								</p> -->
							</div>
							<div class="financial-icon-container financial-blue-bg">
								<i class="fas fa-file-invoice"></i>
							</div>
						</div>
					</div>

					<!-- Purchase Value -->
					<div class="financial-summary-card financial-orange">
						<div class="financial-summary-header">
							<div>
								<p class="financial-label">Total Purchase Value</p>
								<p class="financial-value">£{{formatCurrency(financial.purchaseLogValue.toFixed(2))}}</p>
								<!-- <p *ngIf="financial.purchaseLogValueChange > 0" class="financial-change financial-up">
									<i class="fas fa-arrow-up"></i> +{{financial.purchaseLogValueChange.toFixed(1)}}% from last
									month
								</p>
								<p *ngIf="financial.purchaseLogValueChange < 0" class="financial-change financial-down">
									<i class="fas fa-arrow-down"></i> -{{financial.purchaseLogValueChange.toFixed(1)}}% from last
									month
								</p> -->
							</div>
							<div class="financial-icon-container financial-orange-bg">
								<i class="fas fa-shopping-cart"></i>
							</div>
						</div>
					</div>

					<!-- Purchase Count -->
					<div class="financial-summary-card financial-purple">
						<div class="financial-summary-header">
							<div>
								<p class="financial-label">Total Purchase Count</p>
								<p class="financial-value">{{financial.purchaseLogCount}}</p>
								<!-- <p *ngIf="financial.purchaseLogCountChange > 0" class="financial-change financial-up">
									<i class="fas fa-arrow-up"></i> +{{financial.purchaseLogCountChange.toFixed(1)}} from last
									month
								</p>
								<p *ngIf="financial.purchaseLogCountChange < 0" class="financial-change financial-down">
									<i class="fas fa-arrow-down"></i> -{{financial.purchaseLogCountChange.toFixed(1)}} from last
									month
								</p> -->
							</div>
							<div class="financial-icon-container financial-purple-bg">
								<i class="fas fa-boxes"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="financial-tables-wrapper">
				<!-- Sales Orders Table -->
				<div class="financial-table-card">
					<div class="financial-table-header">
						<h3 class="financial-table-title">
							Recent Invoices (Month to Date)
						</h3>
					</div>
					<div class="financial-table-scroll">
						<dx-data-grid class="data-grid" [dataSource]="financial.invoices" [remoteOperations]="false" [allowColumnReordering]="false" [rowAlternationEnabled]="true" [showBorders]="true" style="margin-top: 0">
							<dxo-paging [pageSize]="100"></dxo-paging>
							<dxo-state-storing [enabled]="true" type="localStorage" storageKey="financialDashboardInvoices"></dxo-state-storing>
							<dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
							<dxi-column dataField="id" alignment="left"></dxi-column>
							<dxi-column dataField="createdAt" caption="Created" dataType="date" format="dd/MM/yyyy"></dxi-column>
							<dxi-column dataField="client" caption="Client"></dxi-column>
							<dxi-column dataField="value" caption="Value" alignment="right" [format]="{ type: 'currency', currency: 'GBP', precision: 4 }"></dxi-column>
							<dxi-column type="buttons">
								<dxi-button hint="View" icon="fal fa-eye" [onClick]="viewInvoiceRow"></dxi-button>
							</dxi-column>
						</dx-data-grid>
					</div>
				</div>

				<!-- Purchase Orders Table -->
				<div class="financial-table-card">
					<div class="financial-table-header">
						<h3 class="financial-table-title">Recent Purchase Orders (Month to Date)</h3>
					</div>
					<div class="financial-table-scroll">
						<dx-data-grid class="data-grid" [dataSource]="financial.purchaseLogs" [remoteOperations]="false" [allowColumnReordering]="false" [rowAlternationEnabled]="true" [showBorders]="true" style="margin-top: 0">
							<dxo-paging [pageSize]="100"></dxo-paging>
							<dxo-state-storing [enabled]="true" type="localStorage" storageKey="financialDashboardPurchaseLogs"></dxo-state-storing>
							<dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
							<dxi-column dataField="id" alignment="left"></dxi-column>
							<dxi-column dataField="dueDate" caption="Due Date" dataType="date" format="dd/MM/yyyy"></dxi-column>
							<dxi-column dataField="supplier" caption="Supplier"></dxi-column>
							<dxi-column dataField="value" caption="Value" alignment="right" [format]="{ type: 'currency', currency: 'GBP', precision: 4 }"></dxi-column>
							<dxi-column type="buttons">
								<dxi-button hint="View" icon="fal fa-eye" [onClick]="viewPurchaseLogRow"></dxi-button>
							</dxi-column>
						</dx-data-grid>
					</div>
				</div>
			</div>
		</div>		
		<table *ngIf="financialDashboardMode == 'Production Forecast'" id="productionForecast">
			<thead>
				<tr>
					<th>Client</th>
					<th>Part \ Month</th>
					<th *ngFor="let header of productionForecast.headers">{{header.text}}</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let part of productionForecast.parts">
					<th scope="row" style="background: {{part.clientLocationColour}}">{{part.client}}</th>
					<th scope="row" style="background: {{part.clientLocationColour}}">{{part.partNumber}}</th>
					<td *ngFor="let month of part.months">{{month.totalValue.toLocaleString('en-GB', {style: 'currency', currency: 'GBP', minimumFractionDigits: 2})}}</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div *ngIf="mode === 'Goods In'" id="goodsIn">
		<table class="goodsInBoardHeader">
			<thead>
				<tr>
					<th><img src="../../../assets/full-logo.jpg" /></th>
					<th>Goods In Dashboard</th>
					<th>Last Update</th>
					<th>{{today}}</th>
				</tr>
			</thead>
		</table>
		<div class="color-key-container">
			<h3 class="color-key-title">Color Key</h3>
			<div class="color-key-items">
				<div class="color-key-item">
					<span class="color-swatch gi-received"></span> Received
				</div>
				<div class="color-key-item">
					<span class="color-swatch gi-pending"></span> Pending
				</div>
				<div class="color-key-item" *ngFor="let siteColour of siteColours">
					<span class="color-swatch siteColour" style="background: {{siteColour.colour}}"></span> {{siteColour.site}}
				</div>
			</div>
		</div>
		<div class="calendar-container">
			<div class="week" *ngFor="let week of goodsInDashboard">
				<div class="week-header">{{ week.header }}</div>
				<div class="days-grid">
					<div class="day" *ngFor="let day of week.columns">
						<div class="{{day.isEndOfMonth == true ? 'day-label-eom' : 'day-label'}}">
							{{day.day}}<br />{{day.date}}
						</div>
						<div *ngFor="let purchaseLog of day.purchaseLogs" class="event-card {{purchaseLog.received === true ? 'gi-received' : 'gi-pending'}}">
							<div class="event-site" style="background: {{purchaseLog.siteColour}}"></div>
							<div class="event-desc">
								<strong>{{purchaseLog.id}}</strong> — {{purchaseLog.supplier}}
							</div>
							<div class="event-desc">Lines: {{purchaseLog.lineItems}} &nbsp;&nbsp;&nbsp; Site: {{purchaseLog.site}}</div>
							<div class="event-actions">
								<i *ngIf="purchaseLog.received" class="fas fa-check tick-icon"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="mode === 'Promises'" id="promises" style="padding-bottom: 20px">
		<table class="promiseBoardHeader">
			<thead>
				<tr>
					<th><img src="../../../assets/full-logo.jpg" /></th>
					<th>Weekly Promise</th>
					<th>Last Update</th>
					<th>{{today}}</th>
				</tr>
			</thead>
		</table>
		<div class="color-key-container">
			<h3 class="color-key-title">Color Key</h3>
			<div class="color-key-items">
				<div class="color-key-item">
					<span class="color-swatch internal"></span> Internal
				</div>
				<div class="color-key-item">
					<span class="color-swatch external"></span> External/Client
				</div>
				<div class="color-key-item">
					<span class="color-swatch completed"></span> Completed
				</div>
				<div class="color-key-item">
					<span class="color-swatch private">
						<i class="fas fa-user-lock"></i>
					</span>
					Private
				</div>
				<div class="color-key-item">
					<span class="color-swatch">
						<i class="fas fa-exclamation exclam-icon" style="color: red"></i>
					</span>
					Overdue
				</div>
				<div class="color-key-item" style="float: right; right: 0">
					<dx-select-box [dataSource]="promiseDepartments" displayExpr="name" placeholder="Filter" valueExpr="id" [showClearButton]="true" (onValueChanged)="departmentFilterChanged($event)"></dx-select-box>
				</div>
			</div>
		</div>
		<div class="calendar-container">
			<div class="week" *ngFor="let week of promiseBoard">
				<div class="week-header">{{ week.header }}</div>
				<div class="days-grid">
					<div class="day" *ngFor="let day of week.columns">
						<div class="{{day.isEndOfMonth == true ? 'day-label-eom' : 'day-label'}}">
							{{day.day}}<br />{{day.date}}
						</div>
						<div *ngFor="let event of day.promises" class="event-card"
							class="{{event.completed === true ? ' completed' : event.promiseType === 10 ? 'internal' : 'external'}}{{event.isPrivate === true ? ' private' : ''}}">
							<div class="event-desc">
								{{ event.description }}
							</div>
							<div class="event-actions">
								<i *ngIf="checkOverDue(event.promiseDate)  && !event.completed && !event.isPrivate" class="fas fa-exclamation exclam-icon"></i>
								<i *ngIf="event.completed" class="fas fa-check tick-icon"></i>
								<i *ngIf="event.isPrivate" class="fas fa-user-lock lock-icon"></i>
								<a href="#" (click)="editPromisePopup(event)"><i class="fas fa-edit"></i></a>
								<a href="#" (click)="deletePromise(event)"><i class="fas fa-trash"></i></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="mode === 'Sales'" id="sales" style="padding-bottom: 20px">
		<table class="promiseBoardHeader">
			<thead>
				<tr>
					<th><img src="../../../assets/full-logo.jpg" /></th>
					<th>Weekly Promise</th>
					<th>Last Update</th>
					<th>{{today}}</th>
				</tr>
			</thead>
		</table>
		<div class="color-key-container">
			<h3 class="color-key-title">Color Key</h3>
			<div class="color-key-items">
				<div class="color-key-item">
					<span class="color-swatch completed"></span> Completed
				</div>
				<div class="color-key-item">
					<span class="color-swatch private">
						<i class="fas fa-user-lock"></i>
					</span>
					Private
				</div>
				<div class="color-key-item">
					<span class="color-swatch">
						<i class="fas fa-exclamation exclam-icon" style="color: red"></i>
					</span>
					Overdue
				</div>
				<div class="color-key-item" style="float: right; right: 0">
					<dx-select-box [dataSource]="promiseDepartments" displayExpr="name" placeholder="Filter" valueExpr="id" [showClearButton]="true" (onValueChanged)="salesDepartmentFilterChanged($event)"></dx-select-box>
				</div>
			</div>
		</div>
		<div class="calendar-container">
			<div class="week" *ngFor="let week of salesPromiseBoard">
				<div class="week-header">{{ week.header }}</div>
				<div class="days-grid">
					<div class="day" *ngFor="let day of week.columns">
						<div class="{{day.isEndOfMonth == true ? 'day-label-eom' : 'day-label'}}">
							{{day.day}}<br />{{day.date}}
						</div>
						<div *ngFor="let event of day.promises" class="event-card"
							class="{{event.completed === true ? ' completed' : ''}}{{event.isPrivate === true ? ' private' : ''}}">
							<div class="event-desc">
								{{ event.description }}
							</div>
							<div class="event-actions">
								<i *ngIf="checkOverDue(event.promiseDate) && !event.completed && !event.isPrivate" class="fas fa-exclamation exclam-icon"></i>
								<i *ngIf="event.completed" class="fas fa-check tick-icon"></i>
								<i *ngIf="event.isPrivate" class="fas fa-user-lock lock-icon"></i>
								<a href="#" (click)="editPromisePopup(event)"><i class="fas fa-edit"></i></a>
								<a href="#" (click)="deletePromise(event)"><i class="fas fa-trash"></i></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="mode === 'Old Sales'" id="oldSales">
		<div class="row">
			<div class="col-3">
				<dx-pie-chart palette="bright" [dataSource]="myBreakdown">
					<dxi-series argumentField="type" valueField="amount">
						<dxo-label [visible]="true">
							<dxo-connector [visible]="true" [width]="1"></dxo-connector>
						</dxo-label>
					</dxi-series>
					<dxo-size [height]="250" [width]="300"></dxo-size>
				</dx-pie-chart>
			</div>
			<div class="col-3 text-center py-5">
				<label class="d-block fs-20">Sales Value (30 Days)</label>
				<label class="d-block fs-30">£{{thirtyDayValue}}</label>
			</div>
			<div class="col-3 text-center py-5">
				<label class="d-block fs-20">Quotes Waiting Approval</label>
				<label class="d-block fs-30">{{quotesWaitingApproval}}</label>
			</div>
			<div class="col-3 text-center py-5">
				<label class="d-block fs-20">Quotes Sent</label>
				<label class="d-block fs-30">{{quotesSent}}</label>
			</div>
		</div>
		<div class="row">
			<div class="col-3">
				<a>
					<div class="button-container">
						<div class="icon">
							<div><i class="fal fa-question"></i></div>
						</div>
						<div class="icon-text">Enquiries</div>
					</div>
				</a>
			</div>
			<div class="col-3">
				<a>
					<div class="button-container">
						<div class="icon">
							<i class="fal fa-conveyor-belt-alt"></i>
						</div>
						<div class="icon-text">Production Quotes</div>
					</div>
				</a>
			</div>
			<div class="col-3">
				<a>
					<div class="button-container">
						<div class="icon"><i class="fal fa-hammer"></i></div>
						<div class="icon-text">Prototype Quotes</div>
					</div>
				</a>
			</div>
			<div class="col-3">
				<a>
					<div class="button-container">
						<div class="icon"><i class="fal fa-chart-pie"></i></div>
						<div class="icon-text">Sales Analysis</div>
					</div>
				</a>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<dx-data-grid class="data-grid" [dataSource]="mySummary" [remoteOperations]="false" [allowColumnReordering]="false" [rowAlternationEnabled]="true" [showBorders]="true">
					<dxo-paging [pageSize]="100"></dxo-paging>
					<dxo-state-storing [enabled]="true" type="localStorage" storageKey="salesDashboardMySummary"></dxo-state-storing>
					<dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
					<dxi-column type="buttons">
						<dxi-button hint="View" icon="fal fa-eye" [onClick]="viewSalesEnquiryRow"></dxi-button>
					</dxi-column>
					<dxi-column dataField="quoteNumber" alignment="left"></dxi-column>
					<dxi-column dataField="createdAt" caption="Date Created" dataType="date" format="dd/MM/yyyy"></dxi-column>
					<dxi-column dataField="client.name" caption="Customer Name"></dxi-column>
					<dxi-column dataField="enquiryValue" caption="Quote Value" alignment="right" [format]="{ style: 'currency', currency: 'GBP', useGrouping: true, minimumSignificantDigits: 3 }"></dxi-column>
					<dxi-column dataField="enquiryQuantity" alignment="right"></dxi-column>
					<dxi-column [showEditorAlways]="false" dataField="approved" alignment="left" [customizeText]="boolYesNo"></dxi-column>
					<dxi-column [showEditorAlways]="false" dataField="quoted" alignment="left" [customizeText]="boolYesNo"></dxi-column>
					<dxi-column dataField="quoteSubmitted" dataType="date" format="dd/MM/yyyy"></dxi-column>
				</dx-data-grid>
			</div>
		</div>
	</div>
	<div *ngIf="mode === 'Staff'" id="staff" class="stff-section">
		<!-- Summary Cards -->
		<div class="staff-summary-section">
				<div class="staff-summary-grid">
					<!-- Total Staff Count -->
					<div class="staff-summary-card financial-green">
						<div class="staff-summary-header">
							<div>
								<p class="staff-label">Total Staff</p>
								<p class="staff-value">{{staffAttendance?.totalStaff}}</p>
							</div>
							<div class="staff-icon-container financial-green-bg">
								<i class="fas fa-users"></i>
							</div>
						</div>
					</div>
					<!-- Total Clocked In Count -->
					<div class="staff-summary-card financial-blue">
						<div class="staff-summary-header">
							<div>
								<p class="staff-label">Clocked In</p>
								<p class="staff-value">{{staffAttendance?.totalClockedIn}}</p>
							</div>
							<div class="staff-icon-container financial-blue-bg">
								<i class="fas fa-user-plus"></i>
							</div>
						</div>
					</div>
					<!-- Total Clocked Out Count -->
					<div class="staff-summary-card financial-orange">
						<div class="staff-summary-header">
							<div>
								<p class="staff-label">Clocked Out</p>
								<p class="staff-value">{{staffAttendance?.totalClockedOut}}</p>
							</div>
							<div class="staff-icon-container financial-orange-bg">
								<i class="fas fa-user-minus"></i>
							</div>
						</div>
					</div>
					<!-- Total Absent Count -->
					<div class="staff-summary-card financial-purple">
						<div class="staff-summary-header">
							<div>
								<p class="staff-label">Absent</p>
								<p class="staff-value">{{staffAttendance?.totalAbsent}}</p>
							</div>
							<div class="staff-icon-container financial-purple-bg">
								<i class="fas fa-user-times"></i>
							</div>
						</div>
					</div>
				</div>
			</div>

		<!-- Sites Grid -->
		<div class="stff-sites-grid" *ngIf="staffAttendance?.sites?.length">
			<div class="stff-site-card" *ngFor="let site of staffAttendance?.sites">
				<div class="stff-site-header">
					<div class="stff-site-header-left">
						<div class="stff-site-icon">
							<i class="fas fa-building"></i>
						</div>
						<div>
							<h3 class="stff-site-title">{{ site.name }}</h3>
							<p class="stff-site-location">
								{{ site.address }}<span *ngIf="site.postcode">, {{ site.postcode }}</span>
							</p>
						</div>
					</div>
					<div class="stff-site-header-right">
						<button class="stff-fire-roll-btn" (click)="printFireRoll(site)" title="Print fire roll">
							<i class="fas fa-fire"></i>
						</button>
						<span class="stff-site-active-pill">
							{{ site.activeUsers }} Active
						</span>
					</div>
				</div>

				<div class="stff-site-body">
					<div
						*ngFor="let userProfile of site.userProfiles"
						[ngClass]="{
							'stff-staff-row': true,
							'stff-staff-row--late': userProfile.lateCheckIn === true,
							'stff-staff-row--clockedin': userProfile.inActiveSession === true,
							'stff-staff-row--clockedout': userProfile.inActiveSession === false
						}"
					>
						<div class="stff-staff-row-left">
							<div class="stff-avatar-placeholder">
								<i class="fas fa-user"></i>
							</div>
							<div class="stff-staff-text">
								<p class="stff-staff-name">{{ userProfile.name }} <span class="stff-staff-late" *ngIf="userProfile.lateCheckIn === true">L</span></p>
								<p class="stff-staff-time" *ngIf="userProfile.inActiveSession === true">Clocked in: {{ formatTime(userProfile.clockedInTime) }}</p>
								<p class="stff-staff-time" *ngIf="userProfile.inActiveSession === false">Clocked out: {{ formatTime(userProfile.clockedOutTime) }}</p>
							</div>
						</div>
						<i class="fas fa-circle stff-status-dot"></i>
					</div>

					<!-- <button
						type="button"
						class="stff-view-all-btn"
						
					>
						View All ({{ site.activeUsers }} staff)
					</button> -->
				</div>
			</div>
		</div>

		<!-- Existing Holiday Grids (kept as-is functionally, just visually below the new cards) -->
		<dx-form class="m-3" [colCount]="2">
			<dxi-item itemType="group" caption="Day Shift Holidays" [colSpan]="1" [colCount]="1">
				<dx-data-grid class="data-grid" [dataSource]="dayShiftHolidayRequests" [remoteOperations]="false" [allowColumnReordering]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true" [showBorders]="true">
					<dxo-paging [pageSize]="100"></dxo-paging>
					<dxo-state-storing [enabled]="true" type="localStorage" storageKey="storage"></dxo-state-storing>
					<dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
					<dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
					<dxo-group-panel [visible]="true"></dxo-group-panel>
					<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
					<dxo-export [enabled]="true"></dxo-export>
					<dxi-column dataField="requestedById" caption="Employee">
						<dxo-lookup [dataSource]="people" valueExpr="id" displayExpr="fullName"></dxo-lookup>
					</dxi-column>
					<dxi-column dataField="startDate" dataType="date" alignment="left" caption="Start Date" format="dd/MM/yyyy" sortOrder="asc"></dxi-column>
					<dxi-column dataField="startTime" dataType="number" alignment="left" caption="Start Time">
						<dxo-lookup [dataSource]="holidayTimes" displayExpr="name" valueExpr="id"></dxo-lookup>
					</dxi-column>
					<dxi-column dataField="endDate" dataType="date" alignment="left" caption="End Date" format="dd/MM/yyyy"></dxi-column>
					<dxi-column dataField="endTime" dataType="number" alignment="left" caption="End Time">
						<dxo-lookup [dataSource]="holidayTimes" displayExpr="name" valueExpr="id"></dxo-lookup>
					</dxi-column>
				</dx-data-grid>
			</dxi-item>

			<dxi-item itemType="group" caption="Night Shift Holidays" [colSpan]="1" [colCount]="1">
				<dx-data-grid class="data-grid" [dataSource]="nightShiftHolidayRequests" [remoteOperations]="false" [allowColumnReordering]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true" [showBorders]="true">
					<dxo-paging [pageSize]="100"></dxo-paging>
					<dxo-state-storing [enabled]="true" type="localStorage" storageKey="storage"></dxo-state-storing>
					<dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
					<dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
					<dxo-group-panel [visible]="true"></dxo-group-panel>
					<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
					<dxo-export [enabled]="true"></dxo-export>
					<dxi-column dataField="requestedById" caption="Employee">
						<dxo-lookup [dataSource]="people" valueExpr="id" displayExpr="fullName"></dxo-lookup>
					</dxi-column>
					<dxi-column dataField="startDate" dataType="date" alignment="left" caption="Start Date" format="dd/MM/yyyy" sortOrder="asc"></dxi-column>
					<dxi-column dataField="startTime" dataType="number" alignment="left" caption="Start Time">
						<dxo-lookup [dataSource]="holidayTimes" displayExpr="name" valueExpr="id"></dxo-lookup>
					</dxi-column>
					<dxi-column dataField="endDate" dataType="date" alignment="left" caption="End Date" format="dd/MM/yyyy"></dxi-column>
					<dxi-column dataField="endTime" dataType="number" alignment="left" caption="End Time">
						<dxo-lookup [dataSource]="holidayTimes" displayExpr="name" valueExpr="id"></dxo-lookup>
					</dxi-column>
				</dx-data-grid>
			</dxi-item>
		</dx-form>
	</div>

	<div *ngIf="mode === 'Tools'" id="tools"></div>
	<div *ngIf="mode === 'Workload'" id="workload">
		<div class="row">
			<div class="col col-3 clearfix" style="padding: 10px" *ngFor="let person of workloadLogDashboard">
				<div class="col" style="background-color: {{renderWorkloadColours(person.site)}}; border-radius: 20px; border: 1px lightgrey solid; height:300px">
					<div class="row" style="padding:10px; border-top-left-radius: 20px; border-top-right-radius: 20px; width:100%; margin-left:0px; background-color: {{renderWorkloadColoursHeader(person.site)}};">
						<div class="col-2" style="text-align: left; font-size: large">
							{{person.site}}
						</div>
						<div class="col-8" style="text-align: center; font-weight: bold; font-size: large;">
							{{person.fullName}}
						</div>
						<div class="col-2" style="text-align: right; font-size: large" (click)="nudge(person.userProfileId!)">
							<i class="fal fa-hand-point-up"></i>
						</div>
					</div>
					<div class="col-12" style="padding: 10px">
						<p *ngFor="let task of person.workloadLogs">
							- {{task.taskDescription}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<dx-popup [width]="'75%'" [height]="600" [showTitle]="true" [title]="popupTitle" [dragEnabled]="false" [closeOnOutsideClick]="false" [showCloseButton]="false" container=".dx-viewport" [(visible)]="popupVisible">
	<dxi-toolbar-item widget="dxButton" toolbar="bottom" location="before" [options]="popupAddButtonOptions"></dxi-toolbar-item>
	<dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="popupCloseButtonOptions"></dxi-toolbar-item>
	<div *dxTemplate="let data of 'content'">
		<dx-form *ngIf="popupTitle === 'Add New Promise' || popupTitle === 'Edit Promise'" class="m-3" [(formData)]="popupPromise" [showColonAfterLabel]="true" labelLocation="top">
			<dxi-item dataField="promiseDate" editorType="dxDateBox" [editorOptions]="{ displayFormat: 'dd/MM/yyyy', type: 'date' }" [label]="{ text: 'Promise Date' }"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
			<dxi-item dataField="promiseDepartment" editorType="dxSelectBox" [editorOptions]="{ items: promiseDepartments, displayExpr:'name', valueExpr:'id', searchEnabled: true }" [colSpan]="3"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
			<dxi-item *ngIf="mode !== 'Sales'" dataField="promiseType" editorType="dxSelectBox" [editorOptions]="{ items: promiseTypes, displayExpr:'name', valueExpr:'id', searchEnabled: true }" [colSpan]="3"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
			<dxi-item dataField="description"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
			<dxi-item dataField="completed" editorType="dxCheckBox"></dxi-item>
			<dxi-item dataField="isPrivate" editorType="dxCheckBox"></dxi-item>
		</dx-form>
		<dx-form *ngIf="popupTitle === 'New Workload Log'" class="m-3" [(formData)]="workloadLogNew" [showColonAfterLabel]="true" labelLocation="top">
			<dxi-item dataField="assigneeId" editorType="dxSelectBox" [editorOptions]="{ items: workloadLogAssignableUsers, displayExpr:'fullName', valueExpr:'id', searchEnabled: true }" [colSpan]="3"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
			<dxi-item dataField="taskDescription"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-item>
		</dx-form>
		<dx-form *ngIf="popupTitle == 'My Workload Logs'" class="m-3" [(formData)]="workloadLogNew" [showColonAfterLabel]="true" labelLocation="top">
			<dxi-item itemType="group" [colSpan]="1" [colCount]="1">
				<dx-data-grid class="data-grid" [dataSource]="workloadLogsUser" [height]="400" [remoteOperations]="false" [allowColumnReordering]="true" [allowColumnResizing]="true" [rowAlternationEnabled]="true" [showBorders]="true">
					<dxo-paging [pageSize]="100"></dxo-paging>
					<dxo-state-storing [enabled]="true" type="localStorage" storageKey="workloadModal"></dxo-state-storing>
					<dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[10, 25, 50, 100]"></dxo-pager>
					<dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"></dxo-search-panel>
					<dxo-group-panel [visible]="true"></dxo-group-panel>
					<dxo-grouping [autoExpandAll]="false"></dxo-grouping>
					<dxo-export [enabled]="true"></dxo-export>
					<dxi-column dataField="taskDescription" alignment="left"></dxi-column>
				</dx-data-grid>
			</dxi-item>
		</dx-form>
	</div>
</dx-popup>